import { render } from "./contact-support.vue?vue&type=template&id=7d0dc000&lang=pug"
import script from "./contact-support.vue?vue&type=script&lang=js"
export * from "./contact-support.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__